<h2 mat-dialog-title>Download limit reached</h2>

<mat-dialog-content>
  You have reached the maximum download limit for 24h. Please try again later.
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close>Ok</button>
</mat-dialog-actions>
